import { createBrand } from './createBrand';
import { getCriteo } from './getCriteo';
import { getFBGeo } from './getFBGeo';
import { getSiteType } from './getSiteType';
import { getUser } from './getUser';
import { IState } from '../../../shared/store';
import { getCustomUrl } from '../../../shared/tracking/get_custom_url';
import { getLocationIds } from '../../../shared/tracking/get_geo_ids';
import { ISopr1Params, EDealType, EObjectType, EPageType, ESopr1UserTypes } from '../../types/analytics/sopr1';

export const getTrackingObject = (state: IState): ISopr1Params => {
  const {
    userData,
    userGaData,
    abGroup,
    device: { deviceType },
  } = state;
  const { village } = state.villageData;

  const newObjects = village.counterSet ? village.counterSet.total : undefined;

  const FBLocations = village.geo?.address?.details ? (getFBGeo(village.geo.address.details) as string[]) : [];

  return {
    products: [
      {
        id: village.id,
        dealType: EDealType.other,
        objectType: EObjectType.kp,
        position: 1,
        brand: village.builder?.id ? createBrand(village.builder.id, ESopr1UserTypes.developer) : '',
      },
    ],
    page: {
      breadCrumbs: state.villageData.breadcrumbs?.map(item => item.title),
      customPageURL: getCustomUrl(village),
      dealType: EDealType.sale,
      fromDeveloper: 1,
      newObjects,
      objectType: EObjectType.kp,
      offerID: village.id,
      offerPhone: village.builder?.phone ? village.builder.phone : '',
      offersQty: newObjects,
      pageType: EPageType.CardKP,
      offerType: 'KP',
      region: getLocationIds(village.geo).join('-'),
      siteType: getSiteType(deviceType),
    },
    partner: {
      ...getCriteo(userData, userGaData),
      FB_city: FBLocations[FBLocations.length - 1],
      FB_region: FBLocations[0],
    },
    user: getUser({
      userData,
      userGaData,
      abGroup,
    }),
  };
};
